import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from './components/ui/sonner';
import { router } from './routes';
import { createAppQueryClient } from './queryClient';

// Module-scoped singleton — one QueryClient per page load.
// Constructed via the shared factory so the MutationCache.onError toast handler
// is guaranteed to be present (UX-1).
const queryClient = createAppQueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* UX-1: global toast surface — must be outside RouterProvider so it
          survives route transitions, but inside QueryClientProvider so it
          shares the same React tree for potential future context reads. */}
      <Toaster position="bottom-right" />
    </QueryClientProvider>
  );
}
